<script setup lang="ts">
import ToggleSwitch from '@mobile/components/ToggleSwitch/ToggleSwitch.vue'

interface Props {
  label: string
}
defineProps<Props>()

// model
const model = defineModel<boolean>({ default: false })
</script>

<template>
  <div class="flex flex-col">
    <span class="pb-1 text-xs">{{ label }}</span>
    <ToggleSwitch
      v-model:value="model"
      class="-ml-2 py-2"
    />
  </div>
</template>
